export default __webpack_public_path__ + "static/media/zol-kielce.17a9e7a0.png";